/**
 * Switching between a few related lists on one screen.
 *
 * Used where the alternative is three navigation entries for things nobody
 * thinks of separately — a menu is its categories, its dishes and its
 * ingredients, not three destinations.
 */
export function Tabs({ tabs, active, onChange }) {
  return (
    <div role="tablist" className="flex gap-1 overflow-x-auto border-b border-rule">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          role="tab"
          aria-selected={active === tab.id}
          onClick={() => onChange(tab.id)}
          className={`shrink-0 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
            active === tab.id
              ? 'border-brand-400 text-brand-300'
              : 'border-transparent text-ink-2 hover:text-ink'
          }`}
        >
          {tab.label}
          {tab.count !== undefined && (
            <span className="ml-1.5 text-xs tabular-nums text-ink-3">{tab.count}</span>
          )}
        </button>
      ))}
    </div>
  );
}
